import React from "react";
import Board from "./Board";
import { DARK } from "./parts";

// Dark-theme flight board (navy panels, amber accents).
const DarkBoard = (props) => <Board {...props} theme={DARK} />;

export default DarkBoard;
